import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import BusyCover from '../../components/controls/BusyCover/BusyCover';
import Button from '../../components/controls/Button';
import { From } from '../../components/controls/Form';
import Heading from '../../components/controls/Typography/Heading';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import useAuthUtils from '../../utils/useAuthUtils';

import './LoginByWebAdmitToken.less';

const LoginByWebAdmitToken = () => {
  const [impersonateError, setImpersonateError] = useState(false);
  const navigate = useNavigate();
  const auth = useAuthUtils();
  const [isBusy, setIsBusy] = useState(true);

  const onBackClick = () => {
    navigate('/login');
  };

  useEffect(() => {
    document.title = 'Letters Portal - WebAdmit Login';
    setIsBusy(true);
    auth
      .authAsWebAdmitToken()
      .then((result) => {
        result.gdprSet ? navigate('/dashboard') : navigate('/gdpr');
      })
      .catch(() => setImpersonateError(true))
      .finally(() => setIsBusy(false));
  }, []);

  return (
    <main className="lsn-page lsn-page-webadmit-token-login" aria-live="polite" title='Login By WebAdmit Token Page'>
      <Heading className="no-focus-outline text-center" tabIndex={0}>
        {impersonateError ? 'WebAdmit Login failed' : 'Logging in. Please wait ...'}
      </Heading>
      <BusyCover isBusy={isBusy} />
      <From
        title='The link seems to be invalid.'
        isNarrow
        hasBorder
        formAttr={{
          title: 'Wrong Link'
        }}
        isButtonsStack
        hidden={isBusy}
        buttons={<Button
          primary
          onClick={() => onBackClick()}
        >
          Back to Login
        </Button>}
      >
        <TextParagraph>Please go back and try again.</TextParagraph>
      </From>
    </main>
  );
};

export default LoginByWebAdmitToken;
